import { z } from 'zod/v4';

import { fleetVehicleInformationSchema } from '../../fleet/schemas/fleet-device-settings.schema';
import { userSchema } from './user.schema';

export const fleetUserSchema = userSchema
  .extend({
    externalName: z.string().nullable(),
    formattedDataVersion: z.string().nullable(),
  })
  .merge(
    fleetVehicleInformationSchema.omit({
      lastCommunicationRequest: true,
      lastConnected: true,
      deviceId: true,
    })
  );

export type FleetUser = z.infer<typeof fleetUserSchema>;
